module.exports = __webpack_public_path__ + "static/media/cnp.daf7db9d.svg";